export default __webpack_public_path__ + "static/plexus-full-width-2-1e762c858c404cad9cc787a1afb1fe68.webp";